/**
 * @generated SignedSource<<53f9681513f47eef225087ff5b4a6d22>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type CustomFieldsTooltip$data = {
  readonly resourceUsageMetricV2: {
    readonly globalScopedCustomFieldsCount?: AGG$Long | null | undefined;
    readonly projectScopedCustomFieldsCount?: AGG$Long | null | undefined;
  } | null | undefined;
  readonly " $fragmentType": "CustomFieldsTooltip";
};
export type CustomFieldsTooltip$key = {
  readonly " $data"?: CustomFieldsTooltip$data;
  readonly " $fragmentSpreads": FragmentRefs<"CustomFieldsTooltip">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "cloudId"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "metricKey"
    }
  ],
  "kind": "Fragment",
  "name": "CustomFieldsTooltip",
  "selections": [
    {
      "args": [
        {
          "kind": "Variable",
          "name": "cloudId",
          "variableName": "cloudId"
        },
        {
          "kind": "Variable",
          "name": "metricKey",
          "variableName": "metricKey"
        }
      ],
      "kind": "LinkedField",
      "name": "resourceUsageMetricV2",
      "plural": false,
      "selections": [
        {
          "kind": "InlineFragment",
          "selections": [
            {
              "kind": "ScalarField",
              "name": "globalScopedCustomFieldsCount"
            },
            {
              "kind": "ScalarField",
              "name": "projectScopedCustomFieldsCount"
            }
          ],
          "type": "JiraCustomFieldUsageMetric"
        }
      ]
    }
  ],
  "type": "JiraQuery"
};

(node as any).hash = "42a9b9edb6fb9283ff37d663fa3ce970";

export default node;
